import { shouldShowSourcingUpsell } from '@app/src/components/SourcingSolutionPromo/sourcingSolutionHelpers'
import { useAccessibleOrganizations } from '@app/src/context/AccessibleOrganizationsContext'
import { useAccount } from '@app/src/context/AccountContext'

export function useShouldShowSourcingUpsell(): boolean {
  const { accessibleOrganizations } = useAccessibleOrganizations()
  const { account } = useAccount()

  const currentOrganizationId = account?.organization?.id
  const currentOrganization = accessibleOrganizations.find(ao => ao.organization?.id === currentOrganizationId)

  return shouldShowSourcingUpsell({
    assignedSolutions: (currentOrganization?.solution ?? []).map(s => s.solution),
    companySizeRange: currentOrganization?.organization?.companySizeRange,
    revenueRange: currentOrganization?.organization?.revenueRange,
  })
}
